<template>
  <v-layout column justify-center align-center class="mt-4 pt-2">
    <VueCompareImage
      class="hidden-md-and-down"
      hover
      :style="{ minWidth: '1300px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage"
      :rightImage="rightImage"
      :sliderPositionPercentage="sliderPosition"
    />
    <VueCompareImage
      class="hidden-lg-and-up"
      hover
      :style="{ maxWidth: '400px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage2"
      :rightImage="rightImage2"
      :sliderPositionPercentage="sliderPosition"
    />

    <br>
    <h3 class="headline">
  <span>Hello! I'm&nbsp;</span>
    </h3>
    <vue-typer class="display-1" :repeat="0" text="Midhun Nair"></vue-typer>
    <div style="display:flex;">
    <h3 class="headline">
  <span>a&nbsp;</span>
    </h3>
    <vue-typer
    class="headline"
      :text="text1"
      :repeat="Infinity"
      :shuffle="false"
      initial-action="erasing"
      :pre-type-delay="70"
      :type-delay="70"
      :pre-erase-delay="1980"
      :erase-delay="150"
      erase-style="select-back"
      :erase-on-complete="false"
      caret-animation="smooth"
    ></vue-typer></div>
    <br>
    <v-flex xs12 sm6 md4 lg4 xl4>
      <v-card flat color="transparent" max-width="800">
        <v-card-title primary-title>
          <div>
            <h3 class="display-1 mb-0">
              <span>About</span>
              <span class="blue--text">Me</span>
            </h3>
            <div>
              <p class="homeContent title text--secondary">
                I'm a front-end developer and a graphic designer.
                I am passionate about different web technologies like
                <span
                  class="blue--text font-weight-medium"
                >VUE, Php, etc. </span>, building great user experiences,
                fighting for simplicity over complexity and constantly learning.
                <br>Dynamic and innovative designer with 1.5 years of invaluable hands-on experience in handling several simultaneous creative design projects, concept creation, graphic design and video editing works in
                <span class="blue--text font-weight-medium">Silver Oak University IEEE Student Branch</span>,
                a non-profit Organization in the college. Equipped with the ability to escalate brand awareness by utilizing skills gained in the creative industry.
               <br<br>Currently I am pursuing Computer Engineering at <span
                  class="blue--text font-weight-medium"
                >Silver Oak College of Engineering & Technology.</span> I'm also an active member of <span
                  class="blue--text font-weight-medium"
                >Silver Oak University IEEE Student Branch</span>
              </p>
            </div>
          </div>
        </v-card-title>

        <v-card-actions class="hidden-sm-and-down justify-center">
          <v-btn
          class="mx-4"
            v-for="icon in icons"
            :key="icon.icon"
            fab
            dark
            outline
            color="blue"
            :href="icon.href"
            target="_blank"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-actions class="hidden-md-and-up justify-center">
          <v-btn
          style="align:center"
            v-for="icon in icons"
            :key="icon.icon"
            small
            fab
            dark
            outline
            color="blue"
            :href="icon.href"
            target="_blank"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueTyper } from "vue-typer";
import VueCompareImage from "vue-compare-image";

export default {
  metaInfo: {
    title: "Home",
    titleTemplate: "%s ← Midhun Nair",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "description", content: "Midhun Nair's Portfolio." },
      { charset: "utf-8" },
      { property: "og:title", content: "Midhun Nair" },
      { property: "og:site_name", content: "Midhun Nair" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "http://midhunnair.live" },
      {
        property: "og:image",
        content: "https://cdn.image4.io/mndesigns/f_auto/66aa3e55-542a-4355-acb3-2602e5d55414.png"
      },
      { property: "og:description", content: "Midhun Nair's Portfolio" }
    ]
  },
  components: {
    "vue-typer": VueTyper,
    VueCompareImage
  },
  data() {
    return {
      icons: [
        { href: "https://github.com/itsmidhunnair", icon: "fab fa-github" },
    
        { href: "https://twitter.com/midhun_n_a_i_r", icon: "fab fa-twitter" },
        {
          href: "https://www.linkedin.com/in/itsmidhunnair/",
          icon: "fab fa-linkedin-in"
        },
        
        {
          href: "https://www.facebook.com/people/Midhun-M-Nair/100009103022377/",
          icon: "fab fa-facebook-f"
        },

        { href: "https://www.instagram.com/itsmidhunnair",
          icon: "fab fa-instagram"
        },

        {
            href: "https://www.cloudskillsboost.google/public_profiles/a465066c-13ba-4874-8924-bb54e5759342",
            icon: "fa fa-cloud"
        },
      ],
      text1: ["Web Developer", "Front-End Developer", "Web Designer", "Graphic Designer", "UI/UX Designer", "Video Editor"],
      leftImage: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Homepage%2FArtboard%201%400.5x.png?alt=media&token=05dceee3-486e-4b41-aee8-72996606f44a",
      rightImage: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Homepage%2FArtboard%202%400.5x.png?alt=media&token=b151e7c9-bb08-40ff-a7b4-653ebb183ddf",
      leftImage2: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Homepage%2FArtboard%204%400.5x.png?alt=media&token=87261eae-bcf6-417a-8363-7285c35aa18c",
      rightImage2: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Homepage%2FArtboard%203%400.5x.png?alt=media&token=de5a706b-3190-4caa-96d5-796e54d8c8e2",
      sliderLine: 0,
      hSize: 0,
      sliderPosition: 0.5
    };
  }
};
</script>
<style>
@keyframes rocking {
  0%,
  100% {
    transform: rotateZ(-10deg);
  }

  50% {
    transform: rotateZ(10deg);
  }
}

.vue-typer {
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}
.vue-typer .custom.char.typed {
  color: #2196f3;
}
.vue-typer .custom.char.selected {
  color: #eb1912;
}

.vue-typer .custom.caret {
  animation: rocking 1s ease-in-out 0s infinite;
}
.vue-typer .custom.caret.typing {
  background-color: #2196f3;
}
.vue-typer .custom.caret.selecting {
  display: inline-block;
  background-color: #eb1912;
}
.homeContent {
   line-height: 1.5 !important;
   text-align: justify;
}
</style>

